module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "level is-mobile"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [(!_vm.summoner.in_update_queue) ? _c('p', {
    staticClass: "level-item"
  }, [_vm._v("\n      Looked for new games " + _vm._s(_vm.lastUpdateAttempt) + "\n    ")]) : _vm._e(), _vm._v(" "), (_vm.summoner.in_update_queue) ? _c('p', {
    staticClass: "level-item"
  }, [_vm._v("\n      In update queue, this can take a few minutes\n    ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "level-item"
  }, [_c('button', {
    staticClass: "button is-primary is-small",
    class: {
      'is-loading': _vm.updating || _vm.summoner.in_update_queue, 'is-danger': _vm.error
    },
    attrs: {
      "disabled": _vm.justUpdated
    },
    on: {
      "click": _vm.checkForGames
    }
  }, [(!_vm.error) ? _c('span', [_vm._v("CHECK NOW")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('span', [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "level-left"
  }, [_c('p', {
    staticClass: "level-item"
  }, [_c('span', {
    staticClass: "connection-indicator"
  }), _vm._v(" LIVE\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-753a8534","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForceLeagueUpdate.vue
// module id = 406
// module chunks = 1